module.exports = __webpack_public_path__ + "static/media/listtodo.ecfac2f7.svg";